import React from "react";
import { CustomTextField } from "../../../../../../../../components/CustomTextField";
import ButtonIcon from "../../../../../../../../components/buttons/ButtonIcon";
import { CleanIcon } from "../../../../../../../../components/buttons/IconButtons";
import {
    ACCESS_DEVICES_TABS,
    SHIFT_RESOURCE,
    STEPS_CREATE_SHIFT_ACCESS
} from "../../Model/Models";
import TabPanel from "../../../../../../../../components/ResourceAssignment/TabPanel";
import { AddShiftResourceApp } from "../../Functionality/AddShiftResourceApp";
import { AssignedShiftResourceApp } from "../../Functionality/AssignedShiftResourceApp";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * First shift access section: shift name + device Add/Assigned tab panel.
 */
const SectionAccessDevices = ({
                                  id,
                                  item,
                                  handleChange,
                                  emptyFields,
                                  disabled,
                                  handleClearStep,
                                  devices,
                                  setDevices,
                                  selectDeleteDevices,
                                  setSelectDeleteDevices,
                                  searchElement,
                                  setSearchElement,
                                  modified,
                                  setModified,
                                  mainContainerClass
                              }) => {
    return (
        <div className={"row mb-3"}>
            <div className='d-flex justify-content-end col-12 mb-2'>
                {(id === null || typeof id === 'undefined') &&
                <ButtonIcon
                    className='btn-clean-secondary-600'
                    id='btn_sadev_clean_devices'
                    Icon={CleanIcon}
                    title={'clear_instances'}
                    onClick={() => handleClearStep(STEPS_CREATE_SHIFT_ACCESS.ACCESS_DEVICE.INDEX)}
                    iconProps='btn-icon-svg-12px icon-color-general-00'
                />
                }
            </div>

            <div className={"col-12"}>
                <CustomTextField
                    id='txt_sa_name'
                    name='name'
                    value={item?.name}
                    trans='name'
                    type='text'
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields && (item?.name === '' || !item?.name)}
                    required={true}
                    length={64}
                />
            </div>

            <div className={"col-12"}>
                <TabPanel
                    resource={SHIFT_RESOURCE.DEVICES}
                    tabsConfig={ACCESS_DEVICES_TABS}
                    selected={devices}
                    setSelected={setDevices}
                    selectForDelete={selectDeleteDevices}
                    setSelectForDelete={setSelectDeleteDevices}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    modified={modified}
                    setModified={setModified}
                    id={id}
                    deleteButtonId={'btn_sadev_delete'}
                    useAddApp={AddShiftResourceApp}
                    useAssignedApp={AssignedShiftResourceApp}
                    mainContainerClass={mainContainerClass}
                    emptyFields={emptyFields && devices?.length === 0}
                />
            </div>
        </div>
    );
}

export default SectionAccessDevices
